import React from 'react';
import { Column } from '@ant-design/plots';

const DownloadsByFuntion = (props) => {
    const data = [
    ];
    props.functionData.forEach((value)=>{

      var functionName = value.position;
      var length = 13;
      var trimmedFunctionName= functionName.substring(0, length)+'..';

      data.push(
        {
          'FunctionTrimmed':trimmedFunctionName,
          'Function':value.position,
          'Downloads':parseInt(value.downloads),
        }
      )
    })

  const config = {
    data,
    point: {
      size: 5,
      shape: 'diamond',
      style: {
        fill: 'white',
        stroke: '#2593fc',
        lineWidth: 2,
      }},
    xField:'FunctionTrimmed',
    yField:'Downloads',
    meta:false,
    color:'#667AFF',
    columnStyle: {
      radius: [20, 20, 20, 20],
      width:10,
      lineWidth:1
    },
    isStack: true,
    xAxis: {
      label: {
        autoRotate: true,
        autoHide: false,
        autoEllipsis: true,
        style: {
          fontSize: 9
        },
      },
    },
    style:{
      height:260
    },
    minColumnWidth: 15,
    maxColumnWidth: 15,
    scrollbar: {
      type: 'horizontal',
      style: {
        trackColor: '#F0FAFF',
        thumbColor: '#D7F2FF'
      },
    },
    tooltip: {
      showTitle: false,
      fields: ['Function', 'Downloads'],
    }
  };
  if(data.length>0){
    return <Column {...config} />;
  }

};

export default DownloadsByFuntion;
